<template>
  <!--  <div :class="newMessage ? 'message-box-new' : 'message-box-old' ">-->
  <div ref="messageBoxRef" class="message-box">
    <div class="message-box-left">
      <div class="content-detail">
        <div
          v-if="message.isSending"
          style="
            display: flex;
            justify-content: flex-end;
            gap: 0.5em;
            min-width: 75px;
          "
        >
          <p
            class="sending-status"
            style="font-size: 0.75em; margin-bottom: 0; white-space: nowrap"
          >
            {{ $t(message.isSending ? "chat.sending" : "") }}
          </p>
          <b-spinner small label="Small Spinner" />
        </div>
        <p v-else class="sending-status">
          {{ message.createdAt | formatShortDate }}
        </p>
      </div>
      <div>
        <div class="content-message v-html" v-html="message.message" />
      </div>
    </div>
    <div class="message-box-right">
      <b-avatar
        size="35"
        class="profile-operator"
        variant="primary"
        :text="getFirstLetter"
      />
    </div>
    <!--        :text="message.participant.name"-->
  </div>
</template>

<script>
import { BAvatar, BSpinner } from "bootstrap-vue";
import { computed, onMounted, ref } from "@vue/composition-api";

export default {
  components: {
    BAvatar,
    BSpinner,
  },
  props: {
    newMessage: {
      type: Boolean,
      default: false,
    },
    message: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const messageBoxRef = ref();
    const getFirstLetter = computed(() => {
      const stringArray = props.message.participant.name.split(" ");
      return stringArray[0].charAt(0) + stringArray[1].charAt(0);
    });
    onMounted(() => {
      // if (messageBoxRef.value) messageBoxRef.value.classList.add('message-box-new')
    });
    return { messageBoxRef, getFirstLetter };
  },
};
</script>

<style lang="scss">
.content-message {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .h1,
  .h2,
  .h3,
  .h4,
  .h5,
  .h6 {
    color: white !important;
  }

  white-space: break-spaces;
}
</style>

<style lang="scss" scoped>
.fade-animation {
  @keyframes fade-in {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  //animation-name: fade-in;
  //animation-delay: 1s;
  //animation-duration: 3s;
}

.message-box {
  display: flex;
  justify-content: flex-end;
  //margin: 2em 1em 1em;
  margin-bottom: 2em;

  .message-box-left {
    position: relative !important;
  }

  .message-box-right {
  }

  .content-detail {
    margin-top: 0.25em;
    top: 100%;
    right: 0;
    position: absolute !important;
    text-align: end;
    margin-bottom: -0.7rem !important;

    .sending-status {
      white-space: nowrap;
    }
  }

  .content-message {
    background: #8d5185;
    color: white !important;
    padding: 0.7rem 1rem;
    clear: both;
    background-repeat: repeat-x;
    border-radius: 0.357rem;
    box-shadow: 0 4px 8px 0 rgb(47 47 47 / 12%);
    max-width: 650px;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    .h1,
    .h2,
    .h3,
    .h4,
    .h5,
    .h6 {
      color: white !important;
    }

    white-space: break-spaces;
  }
}

.message-box-new {
  @extend .message-box;
  opacity: 0;

  animation-name: fade-in;
  animation-delay: 1s;
  animation-duration: 3s;
}

.message-box-old {
  @extend .message-box;
}

.message-box-right {
  margin-left: 1em;
}

.profile-operator {
  font-weight: 400;
  border: 2px solid white;
  box-shadow: 0 4px 8px 0 rgb(47 47 47 / 12%);
}
</style>
